module.exports = __webpack_public_path__ + "static/media/AdobeCC_Step1b_Image5.0907817f.jpg";